import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from '~/Providers/Moment';

import { DATE_FORMAT, DATE_TIME_FORMAT, DEFAULT_TIME_ZONE } from '~/Redux/Constants';
import { openPresetModal } from '~/Redux/Modules/Events';
import { findCalendarInList, mapCalendarsToList } from '~/Redux/Modules/CalendarAccounts';
import TimeSlot from '~/Components/Pages/Calendar/WeekView/TimeGrid/TimeSlot';
import StickerDrop from '~/Containers/Global/Stickers/StickerDrop/StickerDrop';
import { DrawingTarget } from '~/Components/Global/Drawing/DrawingTarget';
import Selection from '../Selection';
import EventGroup from './EventGroup';
import { TimeBar } from './TimeBar';

import './DaySlot.scss';

export class DaySlot extends Component {
  constructor(props, state) {
    super(props, state);
    this.state = {
      selecting: false,
      hasTimeBar: this.isToday(),
    };
  }

  isToday() {
    return moment().isSame(this.props.day, 'day');
  }

  renderTimeGrid = () => {
    return [...Array(48)].map((item, index) => {
      const { day } = this.props;
      const start = day
        .clone()
        .hour(index / 2)
        .startOf('hour')
        .add((index % 2) * 30, 'minutes');
      const end = start.clone().add(60, 'minutes');
      return (
        <TimeSlot
          key={`time-slot-${index}`}
          day={day}
          start={start}
          end={end}
          hour={index}
          showLabel
          content={item}
          selecting={this.state.selecting}
        />
      );
    });
  };

  handleSelectionChange = selectedIndices => {
    if (!selectedIndices.length) {
      this.setState({ ...this.state, selecting: false });
      return;
    }
    this.setState({ ...this.state, selecting: true });
    const { openPresetModal, day } = this.props;
    let first = selectedIndices[0],
      last = selectedIndices.pop();
    const start = day
      .clone()
      .hour(first / 2)
      .startOf('hour')
      .add((first % 2) * 30, 'minutes');
    const end = day
      .clone()
      .hour(last / 2)
      .startOf('hour')
      .add(((last % 2) + 1) * 30, 'minutes');
    openPresetModal({
      start: start.format(DATE_TIME_FORMAT),
      end: end.format(DATE_TIME_FORMAT),
    });
    setTimeout(() => this.selector.clearSelection());
  };

  setSelector = selector => {
    this.selector = selector;
  };

  componentDidMount = () => {
    let element = document.getElementById('currentTime');
    let scrollParent =
      document.querySelector('.day-events .events-wrapper .scroll-parent .scroll-child') ||
      document.querySelector('.week-wrapper .scroll-parent .scroll-child');
    if (element && scrollParent) {
      scrollParent.scrollTop =
        element.offsetTop - scrollParent.offsetTop - scrollParent.offsetHeight * 0.2;
    }
  };

  componentDidUpdate = () => {
    if ((this.state.hasTimeBar && !this.isToday()) || (!this.state.hasTimeBar && this.isToday())) {
      this.setState({ ...this.state, hasTimeBar: this.isToday() });
    }
  };

  render() {
    const { events, isDragging, day, stickerView } = this.props;
    const defaultCalendar = { color: '#efefef', ...this.props.defaultCalendar };
    const opacity = isDragging ? 0.5 : 1;
    return (
      <div style={{ opacity }} className="day-slot">
        {this.state.hasTimeBar && <TimeBar />}
        <DrawingTarget date={day.format(DATE_FORMAT)}>
          <StickerDrop view={stickerView} date={day.format(DATE_FORMAT)}>
            <div className="day-slot-event-group">
              <EventGroup
                startAt={day.clone().startOf('day')}
                endAt={day.clone().endOf('day')}
                events={events}
              />
            </div>
            <Selection
              ref={this.setSelector}
              enabled
              onSelectionChange={this.handleSelectionChange}
              itemClassName="day-slot-selection-area"
              itemSelectedStyle={{
                background: defaultCalendar.color,
                borderBottomColor: defaultCalendar.color,
              }}
            >
              {this.renderTimeGrid()}
            </Selection>
          </StickerDrop>
        </DrawingTarget>
      </div>
    );
  }
}

DaySlot.propTypes = {
  events: propTypes.array,
  day: propTypes.object,
  isDragging: propTypes.bool,
  stickerView: propTypes.string,
  userTimeZone: propTypes.string,
  openPresetModal: propTypes.func,
  defaultCalendar: propTypes.object,
};

const mapStateToProps = ({ Events, UserOptions, CalendarAccounts }) => {
  const calendars = mapCalendarsToList(CalendarAccounts);
  return {
    isDragging: Events.isDragging,
    defaultCalendar:
      findCalendarInList(calendars, UserOptions.data.calendar_id) ||
      calendars.filter(calendar => calendar.active)[0] ||
      {},
    userTimeZone: moment.tz.guess() || DEFAULT_TIME_ZONE,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPresetModal: event => dispatch(openPresetModal(event)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DaySlot);
